import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { priceTypeBranch } from 'components/pages/dashboard/parcelOrderForBranch/components copy/BranchOrder/BranchParcelOrderPrice';
import OrderSummeryDetail from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderSummery/components/OrderSummeryDetail';
import OrderSummeryParcels from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderSummery/components/OrderSummeryParcels';
import TcCard from 'components/UI/card/TcCard';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC } from 'react';
import OrderSummeryTraceCode from './components/OrderSummeryTraceCode';

import OrderSummeryPayment from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderSummery/components/OrderSummeryPayment';
//import OrderSummeryPayment from 'components/pages/dashboard/ParcelOrder/components/orderSummery/components/OrderSummeryPayment';

interface IOrderSummery {
  packages: packageCreate[];
  orderMethods: orderMethodsState;
  priceList?: priceTypeBranch;
  setTraceCode: (_traceCode: string) => void;
  traceCode: string;
}

const OrderSummery: FC<IOrderSummery> = ({
  packages,
  orderMethods,
  traceCode,
  setTraceCode,
  //  priceList,

  // setTraceCode, traceCode
}) => {
  return (
    <TcCard title='بازبینی و تایید سفارش'>
      <p className='mb-2'>بسته های ارسالی :</p>
      <OrderSummeryParcels packages={packages} />
      <p className='mt-6 mb-2'>اطلاعات ارسال :</p>
      <OrderSummeryDetail orderMethods={orderMethods} />
      <p className='mt-6 mb-2'>روش پرداخت :</p>
      <OrderSummeryPayment orderMethods={orderMethods} />
      <OrderSummeryTraceCode setTraceCode={setTraceCode} traceCode={traceCode} />
    </TcCard>
  );
};

export default OrderSummery;
